module.exports = __webpack_public_path__ + "img/icon_e4.32f9de86.png";